{
    "Accessibility menu": "অভিগম্যতা মেনু",
    "Close": "বন্ধ করুন",
    "Content adjustments": "কন্টেন্ট সামঞ্জস্য",
    "Navigation adjustments": "নেভিগেশন সামঞ্জস্য",
    "Text Align": "টেক্সট প্রান্তিককরণ",
    "Align Left": "বাম দিকে সারিবদ্ধ করুন",
    "Align Center": "মাঝে সারিবদ্ধ করুন",
    "Align Right": "ডানে সারিবদ্ধ করুন",
    "Adjust Font Size": "ফন্ট সাইজ সামঞ্জস্য করুন",
    "Highlight Title": "শিরোনাম উজ্জ্বল করুন",
    "Highlight Links": "লিঙ্কগুলি উজ্জ্বল করুন",
    "Readable Font": "পঠনীয় ফন্ট",
    "Colour adjustments": "রঙ সামঞ্জস্য",
    "Dark Contrast": "গাঢ় বৈসাদৃশ্য",
    "Light Contrast": "হালকা বৈসাদৃশ্য",
    "High Contrast": "উচ্চ বৈসাদৃশ্য",
    "High Saturation": "উচ্চ সম্পৃক্তি",
    "Low Saturation": "নিম্ন সম্পৃক্তি",
    "Monochrome": "একরঙা",
    "Tools": "সরঞ্জাম",
    "Reading Guide": "পড়ার গাইড",
    "Big Cursor": "বড় কার্সর",
    "Increase Font Size": "ফন্ট সাইজ বাড়ান",
    "Decrease Font Size": "ফন্ট সাইজ কমান",
    "Letter Spacing": "অক্ষর ব্যবধান",
    "Line Height": "লাইন উচ্চতা",
    "Font Weight": "ফন্ট পুরুত্ব",
    "Dyslexia Font": "ডাইসলেক্সিয়া ফন্ট",
    "Language": "ভাষা",
    "Accessibility widget": "অভিগম্যতা মেনু খোলুন",
    "Accessibility Profiles": "অভিগম্যতা প্রোফাইল",
    "Cognitive Disability": "জ্ঞানীয় অক্ষমতা",
    "Seizure Safe": "মৃগীরোগীদের জন্য নিরাপদ",
    "Accessibility statement": "অভিগম্যতা বিবৃতি",
    "ADHD": "ADHD",
    "Low Vision": "স্বল্প দৃষ্টি",
    "Pause Animations": "অ্যানিমেশন বন্ধ করুন",
    "Animation paused": "অ্যানিমেশন থামানো হয়েছে",
    "Reset all settings": "সব সেটিংস রিসেট করুন",
    "Shortcut:": "শর্টকাট:",
    "Epilepsy Safe Mode": "মৃগীরোগ নিরাপদ মোড",
    "Mute sounds": "শব্দ নিঃশব্দ করুন",
    "Page read": "পৃষ্ঠা পড়ুন",
    "Page read controls": "পৃষ্ঠা পড়ার নিয়ন্ত্রণ",
    "Pause": "বিরতি",
    "Resume": "পুনরায় শুরু করুন",
    "Stop": "বন্ধ করুন",
    "Settings": "সেটিংস",
    "Speed": "গতি",
    "Voice": "কণ্ঠস্বর",
    "Close accessibility menu": "অ্যাক্সেসিবিলিটি মেনু বন্ধ করুন",
    "Back to accessibility menu": "অ্যাক্সেসিবিলিটি মেনুতে ফিরে যান",
    "Search languages": "ভাষা অনুসন্ধান করুন",
    "Selected language": "নির্বাচিত ভাষা",
    "View accessibility statement (opens in new window)": "অ্যাক্সেসিবিলিটি বিবৃতি দেখুন (নতুন উইন্ডোতে খোলে)",
    "Visit CookieYes website (opens in new window)": "CookieYes ওয়েবসাইট দেখুন (নতুন উইন্ডোতে খোলে)",
    "Reset all accessibility settings to default": "সমস্ত অ্যাক্সেসিবিলিটি সেটিংস ডিফল্টে রিসেট করুন"
}
